import { useEffect, useState } from 'react';
import { useFindPreSelectedContact } from '../../../../hooks/useFindPreSelectedContact';
import { MegaContact } from '../../../../types/contacts';
import { TabsWithTitle } from '../../tabsWithTitle';
import { TopUpMobileContacts } from '../topup-mobile-contacts';
import { TopUpMobilePhone } from '../topup-mobile-phone';

export const TopupMobile = ({ contacts }: { contacts: MegaContact[] }) => {
  const [step, setStep] = useState<'contact' | 'other'>('other');
  const [preSelectedContact, setPreSelectedContact] = useState<MegaContact>();

  const tabList = [{ key: 'other', title: 'Otro Número' }];

  if (contacts.length > 0) {
    tabList.push({ key: 'contact', title: 'Mis Contactos' });
  }

  const findPreSelectedContact = useFindPreSelectedContact();

  useEffect(() => {
    findPreSelectedContact({
      contacts: contacts,
      onPreSelectedContactFound: (contact) => {
        setPreSelectedContact(contact);
        setStep('contact');
      },
    });
  }, [contacts]);

  return (
    <div>
      <TabsWithTitle
        title="Celular a Recargar"
        tabs={tabList}
        activeTab={step}
        wrapperClassName="mt-5"
        onTabChange={(key: string) => setStep(key as 'other' | 'contact')}
      />

      {step === 'other' && <TopUpMobilePhone />}
      {step === 'contact' && (
        <TopUpMobileContacts contacts={contacts} preSelectedContact={preSelectedContact} />
      )}
    </div>
  );
};
